import { TextCodes } from '@api/types/translation/TextCodes';
import { BlockContainer, ContentArea, Title } from '@components';
import { Grid } from '@mui/material';
import { t } from '@translations';
import { lazy, Suspense } from 'react';

const BrochureItem = lazy(() =>
  import('@components').then((module) => ({ default: module.BrochureItem }))
);

//-------
export type BrochuresBlockProps = {
  title?: string;
  content?: any;
};

// COMPONENTS
//------------
export const BrochuresBlock = ({ title, content }: BrochuresBlockProps) => {
  return (
    <BlockContainer>
      <Title color='black' sx={{ textAlign: 'center', marginBottom: 5 }}>
        {title}
      </Title>
      <Grid container spacing={{ xs: 2, md: 8 }}>
        <ContentArea
          content={content}
          wrapperComponent={(props, index) => (
            <Grid item xs={12} sm={4} md={3} key={index}>
              <Suspense fallback={<div>{t(TextCodes.Base.Loading)}</div>}>
                <BrochureItem {...props} />
              </Suspense>
            </Grid>
          )}
        />
      </Grid>
    </BlockContainer>
  );
};
